<template>
  <section
    class="EmptyState"
    role="status"
  >
    <Icon
      class="EmptyState__icon"
      :name="iconName"
      :size="iconSize"
    />
    <div class="EmptyState__content">
      <slot>
        <h2>{{ title }}</h2>
        <p>{{ subtitle }}</p>
      </slot>
    </div>
  </section>
</template>

<script setup lang="ts">
import { IconName, IconSize } from "./Icon.types";
import Icon from "./Icon.vue";

defineProps<{
  iconName: keyof typeof IconName,
  iconSize?: IconSize,
  title?: string,
  subtitle?: string,
}>();
</script>

<style lang="scss" scoped>
.EmptyState {
  --iconSize: 48px;
  display: grid;
  place-items: center center;
  align-content: center;
  align-self: center;
  height: 100%;

  font-stretch: var(--fontWidthExtended);
  text-align: center;
  line-height: 1.5;
}

.EmptyState__icon {
  margin-bottom: 16px;
  color: var(--themeColorNeutral150);
}

.EmptyState__content {
  display: grid;
  gap: 6px;
  width: 100%;
  padding: 0 16px;

  :deep(h2) {
    font-size: 18px;
    font-weight: var(--fontWeightMedium);
  }

  :deep(h3) {
    font-size: 16px;
    font-weight: var(--fontWeightMedium);
  }

  :deep(p) {
    font-size: 14px;
    text-wrap: pretty;
    white-space: pre-line;
  }

  :deep(a) {
    font-weight: var(--fontWeightMedium);
    text-decoration: underline;
  }

  :deep(strong) {
    font-size: 18px;
    font-weight: var(--fontWeightMedium);
  }

  :deep(em) {
    font-size: 14px;
  }

  :deep(hr) {
    width: 100%;
    margin: 16px 0;

    border: none;
    border-top: 1px solid var(--themeColorNeutral100);
  }
}

.EmptyState:deep(.FormButton) {
  justify-self: center;
  width: auto;
  margin-top: 10px;
}
</style>
